export enum KanbanColumnAutomationActionType {
  NOTIFICATION = "NOTIFICATION",
  CREATE_TASK = "CREATE_TASK",
}
